(function () {
    "use strict";

    // @ngInject
    function UpgradeNowControllerCtor($scope, $injector, AnalyticsService, $modalInstance) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'UpgradeNowController';
        AnalyticsService.trackPageView(this, 'UpgradeNowView');

        this.$modalInstance = $modalInstance;
    }


    Controllers.UpgradeNowController = Class(Controllers.BaseController, {

        constructor: UpgradeNowControllerCtor,

        cancel: function cancel() {
            this.$modalInstance.dismiss();
        },

        letsGoClicked: function letsGoClicked() {
            this.$modalInstance.close();
        }
    });
}());
